import {
  GET_EVENTS,
  GET_EVENTS_LIST,
  GET_EVENTS_MINIMAL,
  GET_EVENT,
  ADD_EVENT,
  DELETE_EVENT,
  UPDATE_EVENT,
  EVENTS_LOADING,
  EVENT_LOADING,
  CLEAR_CURRENT_EVENT,
  SET_EVENTS_PAGE
} from '../actions/types';

const initialState = {
  events: [],           // Lightweight list for table
  minimalEvents: [],    // Ultra-lightweight list for dropdowns (only _id and title)
  currentEvent: null,   // Full event data for view/edit pages
  loading: false,       // For list loading
  eventLoading: false,  // For single event loading
  currentPage: 1,       // Current page number
  totalPages: 0,        // Total number of pages
  totalEvents: 0,       // Total number of events
  hasNextPage: false,   // Whether there's a next page
  hasPrevPage: false    // Whether there's a previous page
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_EVENTS_MINIMAL:
      return {
        ...state,
        minimalEvents: action.payload,
        loading: false
      };

    case GET_EVENTS_LIST:
      return {
        ...state,
        events: action.payload.events || action.payload,
        currentPage: action.payload.currentPage || 1,
        totalPages: action.payload.totalPages || 0,
        totalEvents: action.payload.totalEvents || 0,
        hasNextPage: action.payload.hasNextPage || false,
        hasPrevPage: action.payload.hasPrevPage || false,
        loading: false
      };

    case GET_EVENT:
      return {
        ...state,
        currentEvent: action.payload,
        eventLoading: false
      };

    case EVENT_LOADING:
      return { ...state, eventLoading: true };

    case CLEAR_CURRENT_EVENT:
      return { ...state, currentEvent: null, eventLoading: false };

    case ADD_EVENT:
      return {
        ...state,
        // Add lightweight version to list
        events: [
          {
            _id: action.payload._id,
            title: action.payload.title,
            type: action.payload.type,
            date: action.payload.date,
            isActive: action.payload.isActive,
            program: action.payload.program,
            createdAt: action.payload.createdAt,
            updatedAt: action.payload.updatedAt
          },
          ...state.events
        ],
        currentEvent: action.payload
      };

    case UPDATE_EVENT:
      return {
        ...state,
        // Update in list
        events: state.events.map(event =>
          event._id === action.payload._id
            ? {
                _id: action.payload._id,
                title: action.payload.title,
                type: action.payload.type,
                date: action.payload.date,
                isActive: action.payload.isActive,
                program: action.payload.program,
                createdAt: action.payload.createdAt,
                updatedAt: action.payload.updatedAt
              }
            : event
        ),
        currentEvent: action.payload
      };

    case DELETE_EVENT:
      return {
        ...state,
        events: state.events.filter(event => event._id !== action.payload),
        currentEvent: null
      };

    case EVENTS_LOADING:
      return { ...state, loading: true };

    case GET_EVENTS: // Keep for backward compatibility
      return { ...state, events: action.payload, loading: false };

    case SET_EVENTS_PAGE:
      return { ...state, currentPage: action.payload };

    default:
      return state;
  }
} 